import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-2 gap-2 lg:gap-5" }
const _hoisted_2 = { class: "grid lg:grid-cols-3 gap-2 lg:gap-5" }

import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import LinkBox from "@/components/LinkBox.vue";
import Heading from "@/components/Heading.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const user: { name: string } = pb.authStore.model;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, {
      subtitle: _unref(user).name
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Hi there,")
      ])),
      _: 1,
      __: [0]
    }, 8, ["subtitle"]),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("p", null, [
          _createTextVNode(" You are browsing the "),
          _createElementVNode("b", null, "TSG R&D Collaboration Hub"),
          _createTextVNode(", a dedicated place for promoting collaboration and innovation between companies and business units within the TSG ("),
          _createElementVNode("a", {
            class: "default-anchor",
            href: "https://tourismsoftwaregroup.com/",
            target: "_blank"
          }, "Tourism Software Group"),
          _createTextVNode("). ")
        ], -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(LinkBox, {
            route: "business_units",
            title: "Business Units",
            description: "Overview of all TSG business units and their products"
          }),
          _createVNode(LinkBox, {
            route: "tech_landscape",
            title: "Tech Landscape",
            description: "Browse tech stacks used by TSG companies and business units"
          }),
          _createVNode(LinkBox, {
            route: "events",
            title: "Events",
            description: "Overview of future and past events"
          }),
          _createVNode(LinkBox, {
            route: "resources",
            title: "Resources",
            description: "References to resources with relevance to all TSG companies and business units"
          })
        ]),
        _createVNode(Heading, null, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Other things")
          ])),
          _: 1,
          __: [1]
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(LinkBox, {
            url: "mailto:philippe@payyo.ch",
            title: "Feedback",
            description: "If you have suggestions, questions or general feedback, please reach out and help shape this place."
          }),
          _createVNode(LinkBox, {
            url: "https://github.com/trekksoftgroup/collabhub",
            title: "Contribute",
            description: "This project is available on GitHub. All contributions are welcomed."
          })
        ])
      ]),
      _: 1,
      __: [2]
    })
  ], 64))
}
}

})